export const isDevelopmentEnvironment = () => process.env.NODE_ENV === 'development'

export const isRealPunchoutSession = session => !!session?.punchout_buyer

export const isPunchoutOnlyLocation = location => {
  const punchoutSetting = location?.punchout

  return punchoutSetting === 'punchout_only' || punchoutSetting === 1
}

export const isLocationPunchoutEnabled = location => {
  const punchoutSetting = location?.punchout

  if (punchoutSetting === undefined || punchoutSetting === null) return false

  // Support both legacy numeric values and enum-string values from newer serializers.
  return isPunchoutOnlyLocation(location) || punchoutSetting === 'punchout_hybrid' || punchoutSetting === 2
}

export const isSimulatedPunchoutUiMode = currentLocation =>
  isDevelopmentEnvironment() && isLocationPunchoutEnabled(currentLocation)

export const isPunchoutUiMode = ({ session, currentLocation }) =>
  isRealPunchoutSession(session) || isSimulatedPunchoutUiMode(currentLocation)
